import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  GeneralPaySessionData,
  PayHubCashierContractsCashierDeclinePageSettingsResponse,
  PayHubCashierContractsPaymentSessionStateResponse,
} from '../models';

export interface PayHubCashierSessionExtendedState extends PayHubCashierContractsPaymentSessionStateResponse {
  generalData?: GeneralPaySessionData;
  submitResultDescription?: string;
}

export const initialState: PayHubCashierSessionExtendedState = {
  session_id: '',
  action: undefined,
  result_status: undefined,
  session_status: undefined,
  transaction_status: undefined,
  experiment_user_group: undefined,
  decline_page_settings: undefined,
  error_fatal: undefined,
  success_url: undefined,
  fail_url: undefined,
  processing_url: undefined,
  merchant_url: undefined,
  generalData: undefined,
  paygroup_id: undefined,
  submitResultDescription: undefined,
};

const paySessionStateSlice = createSlice({
  name: 'paySessionState',
  initialState,
  reducers: {
    setPaySessionState: (state, { payload }: PayloadAction<PayHubCashierContractsPaymentSessionStateResponse>) => ({
      ...state,
      ...payload,
    }),
    setDefaultPaySessionState: () => ({
      ...initialState,
    }),
    setGeneralSessionState: (state, { payload }: PayloadAction<PayHubCashierContractsPaymentSessionStateResponse>) => {
      state.generalData = payload;
    },
    setSubmitResultDescription: (state, { payload }: PayloadAction<string | undefined>) => {
      state.submitResultDescription = payload;
    },
  },
});

export const paySessionStateSelector = ({
  paySessionState,
}: {
  paySessionState: PayHubCashierContractsPaymentSessionStateResponse;
}): PayHubCashierSessionExtendedState => paySessionState;

export const declineReasonSelector = ({
  paySessionState,
}: {
  paySessionState: PayHubCashierSessionExtendedState;
}): PayHubCashierContractsCashierDeclinePageSettingsResponse | undefined =>
  paySessionState.generalData?.decline_page_settings || paySessionState.decline_page_settings;

export const submitResultDescriptionSelector = ({
  paySessionState,
}: {
  paySessionState: PayHubCashierSessionExtendedState;
}): string | undefined => paySessionState.submitResultDescription;

export const { setPaySessionState, setDefaultPaySessionState, setGeneralSessionState, setSubmitResultDescription } =
  paySessionStateSlice.actions;

export default paySessionStateSlice.reducer;
